/* RevScent theme — interactions
   Cart drawer, bundle selector, gallery, model mist toggles, reviews slider, mobile nav, sticky ATC, reveal-on-scroll. */
(function () {
  'use strict';

  var theme = window.theme || {};
  // Work out the money format from a price rendered in the visitor's currency (e.g. "$1,234.56").
  (function () {
    var sample = theme.moneySample;
    if (!sample) return;
    var map = [['1,234.56', '{{amount}}'], ['1.234,56', '{{amount_with_comma_separator}}'], ['1 234,56', '{{amount_with_space_separator}}'], ["1'234.56", '{{amount_with_apostrophe_separator}}'], ['1234.56', '{{amount}}'], ['1234,56', '{{amount_with_comma_separator}}'], ['1,235', '{{amount_no_decimals}}'], ['1.235', '{{amount_no_decimals_with_comma_separator}}']];
    for (var i = 0; i < map.length; i++) {
      if (sample.indexOf(map[i][0]) > -1) { theme.moneyFormat = sample.replace(map[i][0], map[i][1]); return; }
    }
  })();
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '{{amount}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }
  theme.formatMoney = formatMoney;

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* ---------- Cart API ---------- */
  function fetchJSON(url, options) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, options || {}))
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) {
            var msg = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
            throw new Error(msg);
          }
          return data;
        });
      });
  }
  function getCart() { return fetchJSON(theme.routes.cartJs + '?_=' + Date.now()); }
  function addItems(items) {
    return fetchJSON(theme.routes.cartAdd, { method: 'POST', body: JSON.stringify({ items: items }) });
  }
  function changeLine(key, quantity) {
    return fetchJSON(theme.routes.cartChange, { method: 'POST', body: JSON.stringify({ id: key, quantity: quantity }) });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var lastFocus = null;
  var cfg = {};
  try { cfg = JSON.parse(($('#CartDrawerConfig') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var PROTECT_OFF_KEY = 'rs:protection-off';
  var GIFT_REMOVED_KEY = 'rs:gift-removed';
  var lastCart = null;
  var syncing = false;

  function sessGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sessSet(k, v) { try { v === null ? window.sessionStorage.removeItem(k) : window.sessionStorage.setItem(k, v); } catch (e) {} }

  function updateCart(body) {
    return fetchJSON(theme.routes.cartUpdate || '/cart/update.js', { method: 'POST', body: JSON.stringify(body) });
  }
  function isProtection(item) { return cfg.protectionVariant && item.variant_id === cfg.protectionVariant; }
  function isGift(item) { return item.properties && item.properties._rs_gift; }

  function cartParts(cart) {
    var protection = null, gift = null, regular = [];
    cart.items.forEach(function (item) {
      if (isProtection(item)) protection = item;
      else if (isGift(item)) gift = item;
      else regular.push(item);
    });
    var base = regular.reduce(function (sum, i) { return sum + i.final_line_price; }, 0);
    var count = regular.reduce(function (sum, i) { return sum + i.quantity; }, 0) + (gift ? gift.quantity : 0);
    return { protection: protection, gift: gift, regular: regular, base: base, count: count };
  }

  function updateCountBadges(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
    var label = $('[data-cart-count-label]');
    if (label) label.textContent = count ? '(' + count + ')' : '';
  }

  function iconSvg(name) {
    if (name === 'plus') return '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
    if (name === 'trash') return '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
    if (name === 'gift') return '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4"/><path d="M5 12v9h14v-9M12 8v13M12 8S10.5 3 8 4s.5 4 4 4zm0 0s1.5-5 4-4-.5 4-4 4z"/></svg>';
    if (name === 'x') return '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    return '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>';
  }

  function renderRewards(parts) {
    var box = $('[data-cd-rewards]', drawer);
    if (!box) return;
    var ship = cfg.shipGoal || 0, gift = cfg.giftGoal || 0;
    var max = Math.max(ship, gift);
    if (!max) { box.hidden = true; return; }
    box.hidden = parts.count === 0;
    var base = parts.base;
    var pct = Math.min(100, (base / max) * 100);
    $('[data-cd-rewards-fill]', box).style.width = pct + '%';
    var shipMark = $('[data-cd-mark="ship"]', box), giftMark = $('[data-cd-mark="gift"]', box);
    if (shipMark) { shipMark.style.left = (ship / max * 100) + '%'; shipMark.classList.toggle('is-done', base >= ship); }
    if (giftMark) { giftMark.style.left = (gift / max * 100) + '%'; giftMark.classList.toggle('is-done', base >= gift); }
    var msg;
    function fill(t, amount) { return escapeHtml(t || '').replace('[amount]', '<strong>' + formatMoney(amount) + '</strong>'); }
    if (ship && base < ship) msg = fill(cfg.shipGoalText, ship - base);
    else if (gift && base < gift) msg = ship ? fill(cfg.shipDoneText, gift - base) : fill(cfg.giftGoalText, gift - base);
    else msg = '<span class="cd-rewards__party">' + iconSvg('gift') + '</span>' + escapeHtml(gift ? cfg.giftDoneText : 'You unlocked free shipping!');
    $('[data-cd-rewards-msg]', box).innerHTML = msg;
    box.classList.toggle('is-complete', base >= max);
  }

  function renderItem(item, gift) {
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cd-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
    var discounts = gift ? '' : (item.line_level_discount_allocations || []).map(function (d) {
      return '<div class="cd-item__disc">' + escapeHtml(d.discount_application.title) + ' · −' + formatMoney(d.amount) + '</div>';
    }).join('');
    var compare = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
    var priceHtml = gift && item.final_line_price === 0 ? compare + '<span class="cd-item__free">FREE</span>' : compare + formatMoney(item.final_line_price);
    var img = item.image ? '<img src="' + sizedImage(item.image, 200) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="84" height="84">' : '';
    var qty = gift
      ? '<span class="cd-item__badge">' + iconSvg('gift') + ' Free gift</span>'
      : '<div class="cd-qty">' +
          '<button type="button" data-qty-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">' + iconSvg('minus') + '</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">' + iconSvg('plus') + '</button>' +
        '</div>';
    return '' +
      '<div class="cd-item' + (gift ? ' cd-item--gift' : '') + '" data-key="' + item.key + '">' +
        '<a class="cd-item__img" href="' + item.url + '">' + img + '</a>' +
        '<div class="cd-item__info">' +
          '<a class="cd-item__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
          variant + discounts + qty +
        '</div>' +
        '<div class="cd-item__side">' +
          '<div class="cd-item__price">' + priceHtml + '</div>' +
          '<button type="button" class="cd-item__remove" data-qty-change="' + item.key + '" data-qty="0"' + (gift ? ' data-gift-remove' : '') + ' aria-label="Remove ' + escapeHtml(item.product_title) + '">' + iconSvg('trash') + '</button>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    lastCart = cart;
    if (!drawer) return;
    var parts = cartParts(cart);
    var itemsEl = $('[data-cart-items]', drawer);
    var emptyEl = $('[data-cart-empty]', drawer);
    var footEl = $('[data-cart-foot]', drawer);
    var upsell = $('[data-cd-upsell]', drawer);
    var protect = $('[data-cd-protect]', drawer);
    var giftBox = $('[data-cd-gift]', drawer);
    updateCountBadges(parts.count);
    renderRewards(parts);

    var empty = parts.count === 0;
    emptyEl.hidden = !empty;
    footEl.hidden = empty;
    if (upsell) upsell.hidden = empty;
    if (protect) protect.hidden = empty;
    var trust = $('[data-cd-trust]', drawer);
    if (trust) trust.hidden = empty;

    itemsEl.innerHTML = parts.regular.map(function (i) { return renderItem(i, false); }).join('') +
      (parts.gift ? renderItem(parts.gift, true) : '');

    // Free gift picker
    if (giftBox) {
      var unlocked = cfg.giftGoal && parts.base >= cfg.giftGoal;
      giftBox.hidden = !(unlocked && !parts.gift && !empty);
    }
    // Protection switch
    var toggle = $('[data-cd-protect-toggle]', drawer);
    if (toggle) toggle.checked = !!parts.protection;

    // Discount codes
    var codesEl = $('[data-cd-codes]', drawer);
    var codeWrap = $('[data-cd-code-wrap]', drawer);
    if (codesEl) {
      codesEl.innerHTML = (cart.discount_codes || []).map(function (d) {
        return '<span class="cd-chip' + (d.applicable ? '' : ' cd-chip--bad') + '">' + escapeHtml(d.code) +
          (d.applicable ? '' : ' · not applicable') +
          '<button type="button" data-cd-code-remove="' + escapeHtml(d.code) + '" aria-label="Remove code ' + escapeHtml(d.code) + '">' + iconSvg('x') + '</button></span>';
      }).join('');
    }

    // Totals
    var savings = cart.items.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) + (cart.cart_level_discount_applications || []).reduce(function (s, d) { return s + (d.total_allocated_amount || 0); }, 0);
    var savingsRow = $('[data-cd-savings-row]', drawer);
    savingsRow.hidden = savings <= 0;
    $('[data-cd-savings]', drawer).textContent = '−' + formatMoney(savings);
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    var was = $('[data-cd-was]', drawer);
    if (was) { was.hidden = savings <= 0; was.textContent = formatMoney(cart.total_price + savings); }
    var btnTotal = $('[data-cd-checkout-total]', drawer);
    if (btnTotal) btnTotal.textContent = '· ' + formatMoney(cart.total_price);
  }

  // Keeps the cart consistent: shipping protection on by default, gift removed when no longer earned.
  function syncCart(cart) {
    var parts = cartParts(cart);
    var updates = {};
    var adds = [];
    var empty = parts.count === 0;
    if (cfg.protectionVariant) {
      if (empty && parts.protection) updates[parts.protection.key] = 0;
      else if (!empty && !parts.protection && cfg.protectionDefaultOn && !sessGet(PROTECT_OFF_KEY)) adds.push({ id: cfg.protectionVariant, quantity: 1 });
      else if (parts.protection && parts.protection.quantity > 1) updates[parts.protection.key] = 1;
    }
    if (parts.gift) {
      if (!cfg.giftGoal || parts.base < cfg.giftGoal || empty) updates[parts.gift.key] = 0;
      else if (parts.gift.quantity > 1) updates[parts.gift.key] = 1;
    } else if (cfg.giftGoal && parts.base >= cfg.giftGoal && !empty && !sessGet(GIFT_REMOVED_KEY)) {
      // Auto-add the gift when there's only one option to choose from
      var avail = (cfg.giftVariants || []).filter(function (v) { return v.available; });
      if ((cfg.giftVariants || []).length === 1 && avail.length === 1) adds.push({ id: avail[0].id, quantity: 1, properties: { _rs_gift: 'Free gift' } });
    }
    var hasUpdates = Object.keys(updates).length > 0;
    if (!hasUpdates && !adds.length) return Promise.resolve(cart);
    var chain = Promise.resolve();
    if (hasUpdates) chain = chain.then(function () { return updateCart({ updates: updates }); });
    if (adds.length) chain = chain.then(function () { return addItems(adds); });
    return chain.then(getCart);
  }

  function refreshCart() {
    if (syncing) return Promise.resolve(lastCart);
    syncing = true;
    return getCart()
      .then(syncCart)
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {})
      .then(function (cart) { syncing = false; return cart; });
  }
  theme.refreshCart = refreshCart;

  function openDrawer() {
    if (!drawer) { window.location.href = theme.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = $('.cd-head__close', drawer);
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  theme.openCart = function () { refreshCart(); openDrawer(); };

  function busy(el, on) { if (el) { el.disabled = on; el.classList.toggle('is-loading', on); } }

  function applyCode(code) {
    code = (code || '').trim();
    var current = ((lastCart && lastCart.discount_codes) || []).map(function (d) { return d.code; });
    if (code && current.indexOf(code) === -1) current.push(code);
    return updateCart({ discount: current.join(',') }).then(function () {
      // Fallback for stores where the cart API doesn't accept codes: the code is still saved for checkout.
      return fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(function () {});
    }).then(refreshCart);
  }
  theme.applyDiscount = applyCode;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && drawer && theme.cartDrawer !== false) {
      e.preventDefault();
      theme.openCart();
      return;
    }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      busy(qtyBtn, true);
      if (qtyBtn.hasAttribute('data-gift-remove')) sessSet(GIFT_REMOVED_KEY, '1');
      changeLine(qtyBtn.getAttribute('data-qty-change'), parseInt(qtyBtn.getAttribute('data-qty'), 10))
        .then(refreshCart)
        .catch(function (err) { alert(err.message); refreshCart(); });
      return;
    }

    var upBtn = e.target.closest('[data-cd-upsell-add]');
    if (upBtn) {
      e.preventDefault();
      var sel = $('[data-cd-upsell-select]', drawer);
      busy(upBtn, true);
      addItems([{ id: parseInt(sel.value, 10), quantity: 1 }])
        .then(refreshCart)
        .catch(function (err) { alert(err.message); })
        .then(function () { busy(upBtn, false); });
      return;
    }

    var giftBtn = e.target.closest('[data-cd-gift-add]');
    if (giftBtn) {
      e.preventDefault();
      var gsel = $('[data-cd-gift-select]', drawer);
      var gid = gsel ? gsel.value : ((cfg.giftVariants || []).filter(function (v) { return v.available; })[0] || {}).id;
      if (!gid) return;
      busy(giftBtn, true);
      sessSet(GIFT_REMOVED_KEY, null);
      addItems([{ id: parseInt(gid, 10), quantity: 1, properties: { _rs_gift: 'Free gift' } }])
        .then(refreshCart)
        .catch(function (err) { alert(err.message); })
        .then(function () { busy(giftBtn, false); });
      return;
    }

    var codeRemove = e.target.closest('[data-cd-code-remove]');
    if (codeRemove) {
      e.preventDefault();
      var drop = codeRemove.getAttribute('data-cd-code-remove');
      var keep = ((lastCart && lastCart.discount_codes) || []).map(function (d) { return d.code; }).filter(function (c) { return c !== drop; });
      updateCart({ discount: keep.join(',') }).then(refreshCart);
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-cd-protect-toggle]')) {
      var parts = lastCart ? cartParts(lastCart) : null;
      t.disabled = true;
      var job;
      if (t.checked) {
        sessSet(PROTECT_OFF_KEY, null);
        job = (parts && parts.protection) ? Promise.resolve() : addItems([{ id: cfg.protectionVariant, quantity: 1 }]);
      } else {
        sessSet(PROTECT_OFF_KEY, '1');
        job = (parts && parts.protection) ? changeLine(parts.protection.key, 0) : Promise.resolve();
      }
      job.then(refreshCart).catch(function (err) { alert(err.message); }).then(function () { t.disabled = false; });
    }
    if (t.matches && t.matches('[data-cd-upsell-select]')) {
      var opt = t.options[t.selectedIndex];
      var priceEl = $('[data-cd-upsell-price]', drawer);
      if (opt && priceEl) priceEl.textContent = formatMoney(opt.getAttribute('data-price'));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cd-code-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var msg = $('[data-cd-code-msg]', drawer);
    var btn = form.querySelector('button');
    if (!input.value.trim()) return;
    busy(btn, true);
    var code = input.value.trim();
    applyCode(code).then(function (cart) {
      var found = ((cart && cart.discount_codes) || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (msg) {
        msg.hidden = false;
        msg.className = 'cd-code__msg ' + (found && found.applicable ? 'is-ok' : 'is-bad');
        msg.textContent = found && found.applicable ? 'Code applied!' : (found ? 'This code isn\'t valid for your cart.' : 'Code saved – it will be applied at checkout.');
      }
      input.value = '';
    }).catch(function (err) {
      if (msg) { msg.hidden = false; msg.className = 'cd-code__msg is-bad'; msg.textContent = err.message; }
    }).then(function () { busy(btn, false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMobileNav(); }
  });
  if (drawer) refreshCart();

  /* ---------- Generic product forms (collection cards, simple forms) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var id = form.querySelector('[name="id"]').value;
    var qtyInput = form.querySelector('[name="quantity"]');
    addItems([{ id: parseInt(id, 10), quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1 }])
      .then(function () { theme.cartDrawer === false ? (window.location.href = theme.routes.cart) : theme.openCart(); })
      .catch(function (err) { alert(err.message); })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* ---------- Bundle selector (product page) ---------- */
  function initBundle(root) {
    var options = $$('.bundle-opt', root);
    if (!options.length) return;
    var sectionEl = root.closest('[data-product-section]') || document;
    var atcButtons = $$('[data-bundle-atc]', sectionEl);
    var errorEl = $('[data-product-error]', sectionEl);
    var stickyPriceEl = $('[data-sticky-price]', sectionEl);

    function selectedOption() { return options.filter(function (o) { return o.classList.contains('is-selected'); })[0] || options[0]; }

    function computeTier(opt) {
      var discount = parseFloat(opt.getAttribute('data-discount')) || 0;
      var selects = $$('select[data-picker]', opt);
      var total = 0, compare = 0, ok = true;
      var items = [];
      selects.forEach(function (sel) {
        var o = sel.options[sel.selectedIndex];
        if (!o || o.disabled) { ok = false; return; }
        var price = parseInt(o.getAttribute('data-price'), 10) || 0;
        var cmp = parseInt(o.getAttribute('data-compare'), 10) || price;
        total += price;
        compare += Math.max(cmp, price);
        items.push(parseInt(sel.value, 10));
      });
      var discounted = Math.round(total * (1 - discount / 100));
      return { ok: ok, items: items, total: discounted, original: total, compare: compare, qty: selects.length, discount: discount };
    }

    function refresh() {
      options.forEach(function (opt) {
        var t = computeTier(opt);
        var priceEl = $('[data-tier-price]', opt);
        var cmpEl = $('[data-tier-compare]', opt);
        var eachEl = $('[data-tier-each]', opt);
        if (priceEl) priceEl.textContent = formatMoney(t.total);
        if (cmpEl) {
          var showCmp = t.compare > t.total;
          cmpEl.textContent = showCmp ? formatMoney(t.compare) : '';
          cmpEl.hidden = !showCmp;
        }
        if (eachEl && t.qty > 1) eachEl.textContent = formatMoney(Math.round(t.total / t.qty)) + ' each';
      });
      var sel = computeTier(selectedOption());
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(sel.total);
      atcButtons.forEach(function (b) {
        b.disabled = !sel.ok;
        var label = $('[data-atc-label]', b);
        if (label) label.textContent = sel.ok ? b.getAttribute('data-label-add') : b.getAttribute('data-label-soldout');
      });
    }

    options.forEach(function (opt) {
      var radio = $('input[type="radio"]', opt);
      opt.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        options.forEach(function (o) { o.classList.remove('is-selected'); var r = $('input[type="radio"]', o); if (r) r.checked = false; });
        opt.classList.add('is-selected');
        if (radio) radio.checked = true;
        refresh();
      });
      $$('select[data-picker]', opt).forEach(function (sel) {
        sel.addEventListener('change', function () {
          // Sync the gallery to the chosen model
          var o = sel.options[sel.selectedIndex];
          var mediaId = o && o.getAttribute('data-media');
          if (mediaId && theme.galleryGoTo) theme.galleryGoTo(mediaId);
          // Keep the first picker of every tier in sync so switching tiers keeps the choice
          if (sel.getAttribute('data-picker') === '1') {
            $$('select[data-picker="1"]', root).forEach(function (other) { if (other !== sel) other.value = sel.value; });
          }
          refresh();
        });
      });
    });

    atcButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var t = computeTier(selectedOption());
        if (!t.ok) return;
        var grouped = {};
        t.items.forEach(function (id) { grouped[id] = (grouped[id] || 0) + 1; });
        var payload = Object.keys(grouped).map(function (id) { return { id: parseInt(id, 10), quantity: grouped[id] }; });
        atcButtons.forEach(function (b) { b.classList.add('is-loading'); });
        if (errorEl) errorEl.hidden = true;
        addItems(payload)
          .then(function () {
            if (theme.cartDrawer === false) { window.location.href = theme.routes.cart; return; }
            theme.openCart();
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { alert(err.message); }
          })
          .then(function () { atcButtons.forEach(function (b) { b.classList.remove('is-loading'); }); });
      });
    });

    // Preselect a model from ?variant= (links from the collection showcase)
    var params = new URLSearchParams(window.location.search);
    var v = params.get('variant');
    if (v) {
      $$('select[data-picker="1"]', root).forEach(function (sel) {
        if (sel.querySelector('option[value="' + v + '"]')) sel.value = v;
      });
      var first = $('select[data-picker="1"]', root);
      if (first) {
        var o = first.options[first.selectedIndex];
        var mediaId = o && o.getAttribute('data-media');
        if (mediaId) setTimeout(function () { theme.galleryGoTo && theme.galleryGoTo(mediaId); }, 60);
      }
    }
    refresh();
  }
  $$('[data-bundle]').forEach(initBundle);

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var slidesEl = $('.gallery__slides', root);
    var slides = $$('.gallery__slide', root);
    var thumbs = $$('.gallery__thumb', root);
    var counter = $('[data-gallery-counter]', root);
    if (!slidesEl || !slides.length) return;
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function goTo(i) {
      i = (i + slides.length) % slides.length;
      slidesEl.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { goTo(idx); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    var ticking = false;
    slidesEl.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(slidesEl.scrollLeft / slidesEl.clientWidth);
        if (i !== current) setActive(i);
        ticking = false;
      });
    }, { passive: true });

    theme.galleryGoTo = function (mediaId) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    };
    setActive(0);
  }
  $$('[data-gallery]').forEach(initGallery);

  /* ---------- Model mist toggles (collection showcase) ---------- */
  $$('[data-mist-toggle]').forEach(function (media) {
    var label = $('[data-mist-label]', media);
    function setState(on) {
      media.classList.toggle('is-misted', on);
      if (label) label.textContent = on ? (label.getAttribute('data-on') || 'Mist on') : (label.getAttribute('data-off') || 'Tap for mist');
    }
    media.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      setState(!media.classList.contains('is-misted'));
    });
    // On touch devices, switch the mist on automatically when the car scrolls into view
    if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { setState(en.isIntersecting && en.intersectionRatio > 0.6); });
      }, { threshold: [0, 0.6, 1] });
      io.observe(media);
    }
  });

  /* ---------- Reviews slider ---------- */
  $$('[data-slider]').forEach(function (root) {
    var track = $('[data-slider-track]', root);
    if (!track) return;
    function step() { var card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 20 : 300; }
    var prev = $('[data-slider-prev]', root), next = $('[data-slider-next]', root);
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (root.hasAttribute('data-autoplay')) {
      var timer = setInterval(function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, 4500);
      ['pointerdown', 'mouseenter', 'focusin'].forEach(function (ev) { root.addEventListener(ev, function () { clearInterval(timer); }, { once: true }); });
    }
  });

  /* ---------- Mobile nav ---------- */
  var mobileNav = $('#MobileNav');
  var menuToggle = $('[data-menu-open]');
  function openMobileNav() {
    if (!mobileNav) return;
    fillMenuReview();
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    var closeBtn = $('.mobile-nav__close', mobileNav);
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
  }
  function closeMobileNav() {
    if (!mobileNav || !mobileNav.classList.contains('is-open')) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (menuToggle) { menuToggle.setAttribute('aria-expanded', 'false'); menuToggle.focus(); }
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { openMobileNav(); return; }
    if (e.target.closest('[data-menu-close]')) { closeMobileNav(); return; }
    // Close the menu when following an in-page link (e.g. #how-it-works)
    var link = e.target.closest('#MobileNav a[href*="#"]');
    if (link) closeMobileNav();
  });
  // Close when switching to desktop width
  window.matchMedia('(min-width: 990px)').addEventListener('change', function (mq) { if (mq.matches) closeMobileNav(); });
  // Keep keyboard focus inside the open menu
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !mobileNav || !mobileNav.classList.contains('is-open')) return;
    var f = $$('a[href], button, summary', mobileNav).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- Review in mobile menu ---------- */
  var REVIEW_KEY = 'revscent:reviews';
  function storeGet(k) { try { return JSON.parse(window.localStorage.getItem(k)); } catch (e) { return null; } }
  function storeSet(k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  // Remember the reviews from any page that has the reviews section,
  // so the menu can show a real review on every page.
  (function collectReviews() {
    var all = [];
    $$('script[data-review-source]').forEach(function (el) {
      try { all = all.concat(JSON.parse(el.textContent) || []); } catch (e) {}
    });
    all = all.filter(function (r) { return r && r.text; });
    if (all.length) storeSet(REVIEW_KEY, all);
  })();

  var menuReviewFilled = false;
  function fillMenuReview() {
    var box = $('[data-menu-review]');
    if (!box || menuReviewFilled) return;
    var pool = storeGet(REVIEW_KEY) || [];
    var picked = pool.filter(function (r) { return r.in_menu; });
    if (!picked.length) picked = pool;
    var review = picked.length ? picked[Math.floor(Math.random() * picked.length)] : null;
    if (!review) {
      var fb = $('script[data-menu-review-fallback]');
      if (fb) { try { review = JSON.parse(fb.textContent); } catch (e) {} }
    }
    if (!review || !review.text) return;
    var star = '<svg class="icon icon--star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';
    var rating = Math.max(1, Math.min(5, parseInt(review.rating, 10) || 5));
    var starsEl = $('[data-menu-review-stars]', box);
    starsEl.innerHTML = new Array(rating + 1).join(star);
    starsEl.setAttribute('aria-label', rating + ' out of 5 stars');
    var titleEl = $('[data-menu-review-title]', box);
    titleEl.textContent = review.title || '';
    titleEl.hidden = !review.title;
    $('[data-menu-review-text]', box).textContent = '“' + review.text + '”';
    var authorEl = $('[data-menu-review-author]', box);
    authorEl.textContent = (review.author || '') + (review.verified && review.author ? ' · Verified buyer' : '');
    $('[data-menu-review-verified]', box).hidden = !review.verified;
    var imgEl = $('[data-menu-review-img]', box);
    if (review.image) {
      imgEl.innerHTML = '<img src="' + escapeHtml(review.image) + '" alt="" width="56" height="56" loading="lazy">';
      imgEl.hidden = false;
    } else {
      imgEl.hidden = true;
    }
    box.hidden = false;
    menuReviewFilled = true;
  }

  /* ---------- Sticky add to cart ---------- */
  var sticky = $('[data-sticky-atc]');
  var mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    var footer = $('.footer');
    var mainVisible = true, footerVisible = false;
    var update = function () { var on = !mainVisible && !footerVisible && mainAtc.getBoundingClientRect().top < 0; sticky.classList.toggle('is-visible', on); document.body.classList.toggle('has-sticky-atc', on); };
    new IntersectionObserver(function (en) { mainVisible = en[0].isIntersecting; update(); }).observe(mainAtc);
    if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); ro.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { ro.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
    $$('[data-bundle]', e.target).forEach(initBundle);
    $$('[data-gallery]', e.target).forEach(initGallery);
  });
  if (window.Shopify && window.Shopify.designMode) reveals.forEach(function (el) { el.classList.add('is-in'); });
})();
